export enum CookiesKey {
  blockRequestTierEmail = 'blockRequestTierEmail',
}
